import $ from "jquery";

const init = () => {
  changeText();
};

const changeText = () => {
  $(".mphb-room-number").text("Guest");
};

try {
  init();
} catch (error) {
  console.log(error);
}
